import request from '@/utils/request'

export function getRegionFromIP(params) {
    return request({
        url: '/ip/region',
        method: 'get',
        params
    })
}